<template>
  <div class="breadcrumbs">
    <!--⬤-->
      <a href="#" 
        v-on:click.prevent="setStep(1)" 
        :class="isThisSelected(1)">
        <div class="bread__content">
          <p class="title">Products</p>
          <p class="item-selected">Products Grid</p>
        </div>
      </a>
      <a href="#" 
        v-if="current_product" 
        v-on:click.prevent="setStep(2)"
        :class="isThisSelected(2)">
        <span></span>
        <div class="bread__content">
          <p class="title">{{this.current_product.name}}</p>
          <p class="item-selected">Single Product</p>
        </div>
      </a>
      <a class="loader__content" v-if="loading">
        <span></span>
        <gheom-loader
        :dim=50
        :mode=4>
        </gheom-loader>
      </a>
      <div v-else>
        <a href="#"
          v-if="current_gheom" 
          v-on:click.prevent="setStep(3)"
          :class="isThisSelected(3)">
          <span></span>
          <div class="bread__content">
            <p class="title">
              {{this.current_gheom.name}}
            </p>
            <p class="item-selected">Single Gheom</p>
          </div>
        </a>
      </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: [
    "current_step", "current_product", "current_gheom", "loading"
  ],
  data:function(){ 
    return {

    }
  },
  computed:{
  }, 
  methods: {
    setStep(step){
      this.$emit('onstepchanged', step)
    }, 
    isThisSelected(ord) {
      if (this.current_step == ord) {
        return "selected"
      }
    }   
  }
}
</script>


